	import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";
import { ConfigService } from '../ConfigService';
import { BlobResponse } from '../../Models/OtherClasses';

@Injectable()
export class ChecklistService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private configData: ConfigService,
		private urlService: UrlService
	){
		this.url = urlService.getURL('Checklist');
	}
	
	loadAll(id: System.Guid) : Observable<ePM.Logic.Checklist[]> {
		if (!id) {
			id = '';
		}
		return this.myBaseService.loadAll(this.url + '/Person/' + id);
	}
	loadDueDateTrackers(id: System.Guid): Observable<ePM.Logic.DueDateTracker[]> {
		return this.myBaseService.loadAll(this.url + '/' + (id ?? '') + '/DueDateTrackers');
	}
	loadAllForCompany(): Observable<ePM.Logic.Checklist[]> {
		return this.myBaseService.loadAll(this.url + '/Company');
	}
	loadAllMasters(): Observable<ePM.Logic.Checklist[]> {
		return this.myBaseService.loadAll(this.url + '/Masters');
	}
	save(tempItem: ECI.Basic.ObjectBase) : Observable<ePM.Logic.Checklist> {
		return this.myBaseService.save(tempItem, this.url);
	}
	copy(tempItem: ePM.Logic.ChecklistCopyVM): Observable<ePM.Logic.Checklist> {
		var url: string = this.url + '/Copy';
		return this.myBaseService.save(tempItem, url);
	}
	deployToAllCompanies(tempItem: ePM.Logic.Checklist): Observable<ePM.Logic.Checklist> {
		var url: string = this.url + '/Deploy/' + tempItem.ChecklistID;
		return this.myBaseService.post(null, url);
	}
	deployToSpecificCompany(tempItem: ePM.Logic.Checklist, newCompID: System.Guid): Observable<ePM.Logic.Checklist> {
		var url: string = this.url + '/DeploySpecific/' + tempItem.ChecklistID +'?newCompanyID=' + newCompID;
		return this.myBaseService.post(null, url);
	}
	assign(tempItem: ePM.Logic.ChecklistCopyVM): Observable<ePM.Logic.Checklist> {
		var url: string = this.url + '/Assign';
		return this.myBaseService.save(tempItem, url);
	}

	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<ePM.Logic.Checklist> {
		return this.myBaseService.getEdit(id, this.url);
	}
	get(id: System.Guid) : Observable<ePM.Logic.Checklist>{
		return this.myBaseService.get(id, this.url);
	}
	download(id: System.Guid): Observable<BlobResponse>{
		return this.myBaseService.loadBlob(this.url + '/Export/' + id);
	}

}
